import type {ReactNode} from 'react'

interface InlineEmptyTextProps {
    children: ReactNode
    'data-testid'?: string
}

export function InlineEmptyText({children, 'data-testid': testId = 'inline-empty-text'}: InlineEmptyTextProps) {
    return (
        <p data-testid={testId} className="py-4 text-center text-muted-foreground text-sm">
            {children}
        </p>
    )
}
